<template>
  <div>
    <vs-row class="mb-4">
      <vs-col>
        <h5>
          <i class="dot"></i>증상조사 대상자 정보
        </h5>
      </vs-col>
    </vs-row>

    <!-- PC 레이아웃 -->
    <div
      v-if="!isMobile"
      class="grid flex-wrap"
      style="grid-template-columns: 1fr 1fr 1fr; column-gap: 1.5rem"
    >

      <!-- 성명 -->
      <vs-row class="mb-4" style="display: grid; grid-template-columns: 128px 1fr" vs-align="center">
        <vs-col class="title">성명</vs-col>
        <vs-col>
          <div v-if="isPrint" class="print-input">{{ form.name }}</div>
          <ml-input v-else class="w-full" v-model="form.name" :readonly="readonly" />
        </vs-col>
      </vs-row>

      <!-- 연령 -->
      <vs-row class="mb-4" style="display: grid; grid-template-columns: 128px 1fr" vs-align="center">
        <vs-col class="title">연령</vs-col>
        <vs-col class="grid" style="grid-template-columns: auto 1fr auto" vs-align="center">
          <span class="title mr-2">만</span>
          <div v-if="isPrint" class="print-input text-right" >{{ form.age }}</div>
          <ml-input v-else class="w-full" v-model="form.age" :readonly="readonly" />
          <span class="title ml-2">세</span>
        </vs-col>
      </vs-row>

      <!-- 성별 -->
      <vs-row class="mb-4" style="display: grid; grid-template-columns: 128px 1fr" vs-align="center">
        <vs-col class="title">성별</vs-col>
        <vs-col class="grid" vs-align="center">
          <div v-if="isPrint" class="print-input text-right">{{ form.gender }}</div>
          <div v-else>
            <vs-radio class="mr-4" v-model="form.gender" vs-value="남" color="secondary" :disabled="readonly">남</vs-radio>
            <vs-radio v-model="form.gender" vs-value="여" color="secondary" :disabled="readonly">여</vs-radio>
          </div>
        </vs-col>
      </vs-row>

      <!-- 현 직장경력 (~년/개월) -->
      <vs-row class="mb-4" style="display: grid; grid-template-columns: 128px 1fr" vs-align="center">
        <vs-col class="title">현 직장경력<br>(~년/개월)</vs-col>
        <vs-col class="grid" vs-align="center">
          <div v-if="isPrint" class="print-input text-right" >{{ form.workExperience }}</div>
          <ml-input v-else class="w-full" v-model="form.workExperience" :readonly="readonly" />
        </vs-col>
      </vs-row>

      <!-- 작업부서 (~부/라인) -->
      <vs-row class="mb-4" style="display: grid; grid-template-columns: 128px 1fr" vs-align="center">
        <vs-col class="title">작업부서<br>(~부/라인)</vs-col>
        <vs-col class="grid" vs-align="center">
          <div v-if="isPrint" class="print-input text-right" >{{ form.workDepartment }}</div>
          <ml-input v-else class="w-full" v-model="form.workDepartment" :readonly="readonly" />
        </vs-col>
      </vs-row>

      <!-- 작업(수행작업) -->
      <vs-row class="mb-4" style="display: grid; grid-template-columns: 128px 1fr" vs-align="center">
        <vs-col class="title">작업(수행작업)</vs-col>
        <vs-col class="grid" vs-align="center">
          <div v-if="isPrint" class="print-input text-right" >{{ form.workPerform }}</div>
          <ml-input v-else class="w-full" v-model="form.workPerform" :readonly="readonly" />
        </vs-col>
      </vs-row>

      <!-- 결혼여부 -->
      <vs-row class="mb-4" style="display: grid; grid-template-columns: 128px 1fr" vs-align="center">
        <vs-col class="title">결혼여부</vs-col>
        <vs-col class="grid" vs-align="center">
          <div v-if="isPrint" class="print-input text-right" >{{ form.marriage }}</div>
          <div v-else>
            <vs-radio class="mr-4" v-model="form.marriage" vs-value="미혼" color="secondary" :disabled="readonly">미혼</vs-radio>
            <vs-radio v-model="form.marriage" vs-value="기혼" color="secondary" :disabled="readonly">기혼</vs-radio>
          </div>
        </vs-col>
      </vs-row>
      <div></div>
      <div></div>

      <!-- 현재하고 있는 작업(구체적으로) -->
      <vs-row class="mb-4" style="display: grid; grid-template-columns: 128px 1fr" vs-align="center">
        <vs-col class="title">현재하고 있는 작업<br>(구체적으로)</vs-col>
        <vs-col class="grid" vs-align="center">
          <div v-if="isPrint" class="print-input text-right" >{{ form.currentWork }}</div>
          <ml-input v-else class="w-full" v-model="form.currentWork" :readonly="readonly" />
        </vs-col>
      </vs-row>

      <!-- 현재하고 있는 작업: 작업시간 -->
      <vs-row class="mb-4" style="display: grid; grid-template-columns: 128px 1fr" vs-align="center">
        <vs-col class="title">현재하고 있는 작업<br>(구체적으로)</vs-col>
        <vs-col class="grid" vs-align="center">
          <div v-if="isPrint" class="print-input text-right" >
            {{ form.currentPeriod1 }}
            <span class="px-2">년</span>
            {{ form.currentPeriod2 }}
            <span class="pl-2">개월째 하고 있음</span>
          </div>
          <div v-else class="w-full grid" style="grid-template-columns: 1fr auto 1fr auto; align-items: center;" >
            <ml-input class="w-full" v-model="form.currentPeriod1" :readonly="readonly" />
            <span class="px-2">년</span>
            <ml-input class="w-full" v-model="form.currentPeriod2" :readonly="readonly" />
            <span class="pl-2">개월째 하고 있음</span>
          </div>
        </vs-col>
      </vs-row>
      <div></div>

      <!-- 1일 근무시간 -->
      <vs-row class="mb-4" style="display: grid; grid-template-columns: 128px 1fr" vs-align="center">
        <vs-col class="title">1일 근무시간</vs-col>
        <vs-col class="grid" vs-align="center">
          <div v-if="isPrint" class="print-input text-right" >{{ form.dayWorkTime }}</div>
          <ml-input v-else class="w-full" v-model="form.dayWorkTime" :readonly="readonly" />
        </vs-col>
      </vs-row>

      <!-- 근무 중 휴식시간(식사시간 제외) -->
      <vs-row class="mb-4" style="display: grid; grid-template-columns: 128px 1fr" vs-align="center">
        <vs-col class="title">근무 중 휴식시간<br>(식사시간 제외)</vs-col>
        <vs-col class="grid" vs-align="center">
          <div v-if="isPrint" class="print-input text-right" >
            {{ form.dayRestTime1 }}
            <span class="px-2">분씩</span>
            {{ form.dayRestTime2 }}
            <span class="pl-2">회 휴식</span>
          </div>
          <div v-else class="w-full grid" style="grid-template-columns: 1fr auto 1fr auto; align-items: center;" >
            <ml-input class="w-full" v-model="form.dayRestTime1" :readonly="readonly" />
            <span class="px-2">분씩</span>
            <ml-input class="w-full" v-model="form.dayRestTime2" :readonly="readonly" />
            <span class="pl-2">회 휴식</span>
          </div>
        </vs-col>
      </vs-row>
      <div></div>

      <!-- 현작업을 하기 전에 했던 작업 -->
      <vs-row class="mb-4" style="display: grid; grid-template-columns: 128px 1fr" vs-align="center">
        <vs-col class="title">현작업을 하기 전에<br>했던 작업</vs-col>
        <vs-col class="grid" vs-align="center">
          <div v-if="isPrint" class="print-input text-right" >{{ form.prevWork }}</div>
          <ml-input v-else class="w-full" v-model="form.prevWork" :readonly="readonly" />
        </vs-col>
      </vs-row>

      <!-- 현재하고 있는 작업: 작업시간 -->
      <vs-row class="mb-4" style="display: grid; grid-template-columns: 128px 1fr" vs-align="center">
        <vs-col class="title">현재하고 있는 작업<br>(구체적으로)</vs-col>
        <vs-col class="grid" vs-align="center">
          <div v-if="isPrint" class="print-input text-right" >
            {{ form.prevPeriod1 }}
            <span class="px-2">년</span>
            {{ form.prevPeriod2 }}
            <span class="pl-2">개월째 하고 있음</span>
          </div>
          <div v-else class="w-full grid" style="grid-template-columns: 1fr auto 1fr auto; align-items: center;" >
            <ml-input class="w-full" v-model="form.prevPeriod1" :readonly="readonly" />
            <span class="px-2">년</span>
            <ml-input class="w-full" v-model="form.prevPeriod2" :readonly="readonly" />
            <span class="pl-2">개월째 하고 있음</span>
          </div>
        </vs-col>
      </vs-row>
      <div></div>
    </div>

    <!-- 모바일 레이아웃 -->
    <div v-if="isMobile" class="mobile-form-container">
      <!-- 성명 -->
      <div class="mobile-field-item">
        <div class="mobile-label">성명</div>
        <div class="mobile-input">
          <div v-if="isPrint" class="print-input">{{ form.name }}</div>
          <ml-input v-else class="w-full" v-model="form.name" :readonly="readonly" />
        </div>
      </div>

      <!-- 연령 -->
      <div class="mobile-field-item">
        <div class="mobile-label">연령</div>
        <div class="mobile-input">
          <div v-if="isPrint" class="print-input">{{ form.age }}</div>
          <div v-else class="mobile-age-input">
            <span class="age-prefix">만</span>
            <ml-input class="age-input" v-model="form.age" :readonly="readonly" />
            <span class="age-suffix">세</span>
          </div>
        </div>
      </div>

      <!-- 성별 -->
      <div class="mobile-field-item">
        <div class="mobile-label">성별</div>
        <div class="mobile-input">
          <div v-if="isPrint" class="print-input">{{ form.gender }}</div>
          <div v-else class="mobile-radio-group">
            <vs-radio class="mr-4" v-model="form.gender" vs-value="남" color="secondary" :disabled="readonly">남</vs-radio>
            <vs-radio v-model="form.gender" vs-value="여" color="secondary" :disabled="readonly">여</vs-radio>
          </div>
        </div>
      </div>

      <!-- 현 직장경력 -->
      <div class="mobile-field-item">
        <div class="mobile-label">현 직장경력 (~년/개월)</div>
        <div class="mobile-input">
          <div v-if="isPrint" class="print-input">{{ form.workExperience }}</div>
          <ml-input v-else class="w-full" v-model="form.workExperience" :readonly="readonly" />
        </div>
      </div>

      <!-- 작업부서 -->
      <div class="mobile-field-item">
        <div class="mobile-label">작업부서 (~부/라인)</div>
        <div class="mobile-input">
          <div v-if="isPrint" class="print-input">{{ form.workDepartment }}</div>
          <ml-input v-else class="w-full" v-model="form.workDepartment" :readonly="readonly" />
        </div>
      </div>

      <!-- 작업(수행작업) -->
      <div class="mobile-field-item">
        <div class="mobile-label">작업(수행작업)</div>
        <div class="mobile-input">
          <div v-if="isPrint" class="print-input">{{ form.workPerform }}</div>
          <ml-input v-else class="w-full" v-model="form.workPerform" :readonly="readonly" />
        </div>
      </div>

      <!-- 결혼여부 -->
      <div class="mobile-field-item">
        <div class="mobile-label">결혼여부</div>
        <div class="mobile-input">
          <div v-if="isPrint" class="print-input">{{ form.marriage }}</div>
          <div v-else class="mobile-radio-group">
            <vs-radio class="mr-4" v-model="form.marriage" vs-value="미혼" color="secondary" :disabled="readonly">미혼</vs-radio>
            <vs-radio v-model="form.marriage" vs-value="기혼" color="secondary" :disabled="readonly">기혼</vs-radio>
          </div>
        </div>
      </div>

      <!-- 현재하고 있는 작업(구체적으로) -->
      <div class="mobile-field-item">
        <div class="mobile-label">현재하고 있는 작업 (구체적으로)</div>
        <div class="mobile-input">
          <div v-if="isPrint" class="print-input">{{ form.currentWork }}</div>
          <ml-input v-else class="w-full" v-model="form.currentWork" :readonly="readonly" />
        </div>
      </div>

      <!-- 현재 작업 기간 -->
      <div class="mobile-field-item">
        <div class="mobile-label">현재 작업 기간</div>
        <div class="mobile-input">
          <div v-if="isPrint" class="print-input">
            {{ form.currentPeriod1 }}년 {{ form.currentPeriod2 }}개월째 하고 있음
          </div>
          <div v-else class="mobile-period-input">
            <ml-input class="period-input" v-model="form.currentPeriod1" :readonly="readonly" />
            <span class="period-text">년</span>
            <ml-input class="period-input" v-model="form.currentPeriod2" :readonly="readonly" />
            <span class="period-text">개월째 하고 있음</span>
          </div>
        </div>
      </div>

      <!-- 1일 근무시간 -->
      <div class="mobile-field-item">
        <div class="mobile-label">1일 근무시간</div>
        <div class="mobile-input">
          <div v-if="isPrint" class="print-input">{{ form.dayWorkTime }}</div>
          <ml-input v-else class="w-full" v-model="form.dayWorkTime" :readonly="readonly" />
        </div>
      </div>

      <!-- 근무 중 휴식시간 -->
      <div class="mobile-field-item">
        <div class="mobile-label">근무 중 휴식시간 (식사시간 제외)</div>
        <div class="mobile-input">
          <div v-if="isPrint" class="print-input">
            {{ form.dayRestTime1 }}분씩 {{ form.dayRestTime2 }}회 휴식
          </div>
          <div v-else class="mobile-rest-input">
            <ml-input class="rest-input" v-model="form.dayRestTime1" :readonly="readonly" />
            <span class="rest-text">분씩</span>
            <ml-input class="rest-input" v-model="form.dayRestTime2" :readonly="readonly" />
            <span class="rest-text">회 휴식</span>
          </div>
        </div>
      </div>

      <!-- 현작업을 하기 전에 했던 작업 -->
      <div class="mobile-field-item">
        <div class="mobile-label">현작업을 하기 전에 했던 작업</div>
        <div class="mobile-input">
          <div v-if="isPrint" class="print-input">{{ form.prevWork }}</div>
          <ml-input v-else class="w-full" v-model="form.prevWork" :readonly="readonly" />
        </div>
      </div>

      <!-- 이전 작업 기간 -->
      <div class="mobile-field-item">
        <div class="mobile-label">이전 작업 기간</div>
        <div class="mobile-input">
          <div v-if="isPrint" class="print-input">
            {{ form.prevPeriod1 }}년 {{ form.prevPeriod2 }}개월째 하고 있음
          </div>
          <div v-else class="mobile-period-input">
            <ml-input class="period-input" v-model="form.prevPeriod1" :readonly="readonly" />
            <span class="period-text">년</span>
            <ml-input class="period-input" v-model="form.prevPeriod2" :readonly="readonly" />
            <span class="period-text">개월째 하고 있음</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MusculoskeletalSymptomsSurveyTable',
  props: {
    isPrint: Boolean,
    value: Object,
    readonly: Boolean,
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (this.value[key]) {
            this.form[key] = this.value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler() {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (this.value[key]) {
            this.form[key] = this.value[key];
          }
        }

        this.$emit("input", this.form);
      },
    },
  },
  data () {
    return {
      windowWidth: window.innerWidth,
      form: {
        name: '', //이름
        age: '', //나이
        gender: '남', //성별
        workExperience: '', //현 직장경력 (~년/개월)
        workDepartment: '', //작업부서 (~부/라인)
        workPerform: '', //작업(수행작업)
        marriage: '미혼', //결혼여부
        currentWork: '', //현재하고 있는 작업
        currentPeriod1: '',
        currentPeriod2: '',
        dayWorkTime: '', //1일 작업시간
        dayRestTime1: '',
        dayRestTime2: '',
        prevWork: '', //현작업 이전에 하던 작업
        prevPeriod1: '',
        prevPeriod2: '',
      }
    }
  },
  computed: {
    isMobile() {
      return this.windowWidth < 768;
    }
  },
  mounted() {
    // 화면 크기 변경 감지
    this.handleResize = () => {
      this.windowWidth = window.innerWidth;
    };
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  }
}
</script>

<style scoped lang="scss">
// 모바일 레이아웃 스타일
.mobile-form-container {
  .mobile-field-item {
    margin-bottom: 16px;

    .mobile-label {
      display: block;
      font-size: 14px;
      font-weight: 600;
      color: #333;
      margin-bottom: 8px;
      line-height: 1.4;
    }

    .mobile-input {
      width: 100%;

      .mobile-age-input {
        display: flex;
        align-items: center;
        gap: 8px;

        .age-prefix, .age-suffix {
          font-size: 14px;
          color: #333;
          white-space: nowrap;
        }

        .age-input {
          flex: 1;
        }
      }

      .mobile-radio-group {
        display: flex;
        gap: 16px;
        align-items: center;
      }

      .mobile-period-input,
      .mobile-rest-input {
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;

        .period-input,
        .rest-input {
          flex: 1;
          min-width: 60px;
        }

        .period-text,
        .rest-text {
          font-size: 14px;
          color: #333;
          white-space: nowrap;
        }
      }
    }
  }
}

// 인쇄 시 PC 레이아웃 강제 적용
@media print {
  .mobile-form-container {
    display: none !important;
  }

  [v-if="!isMobile"] {
    display: block !important;
  }
}
</style>
